import { AdeMesError } from "../commonClasses";

declare var angular: any;

module Header {

    export interface HeaderDirectiveScope extends ng.IScope {
        $location: ng.ILocationService;
        hasPrevState: () => boolean;
        doLogout: (event: MouseEvent) => void;
        goPrevState: (event: MouseEvent) => void;
        showReportListLink: () => boolean;
        showCustomersLink: () => boolean;
        goToReportList: (event: MouseEvent) => void;
        goToCustomers: (event: MouseEvent) => void;
    }

    interface BugDataContainer {
        bugType: string;
        bugDescription: string;
    };

    export class HeaderDirective implements ng.IDirective {

        static $inject = ["$location", "$state", "MainService", "RolesService", "HeaderService", "toaster", "$translate"];

        constructor(
            private $location: ng.ILocationService,
            private $state: angular.ui.IStateService,
            protected MainService: any,
            protected RolesService: any,
            protected HeaderService: any,
            protected toaster: toaster.IToasterService,
            protected $translate: angular.translate.ITranslateService
        ) {

        };

        restrict = "E";
        templateUrl = "app/shared/header/header.html";
        replace = true;

        controller = ["$scope", "$state", "RolesService", "toaster", "$mdDialog", "blockUI", "ConfigService", "$translate", "$window", "$location",
            ($scope: any, $state: angular.ui.IStateService, RolesService: any, toaster: toaster.IToasterService,
                $mdDialog: angular.material.IDialogService, blockUI: angular.blockUI.BlockUIService, ConfigService: any,
                $translate: angular.translate.ITranslateService, $window: angular.IWindowService, $location: any) => {
                let _self = this;

                $scope.hasPrevState = (): boolean => {
                    return $state.current.name !== "customers";
                };

                let eventListener = $scope.$on('$locationChangeStart', function (e: any) {
                    let path: string = $location.path();
                    console.log("path", path);
                    console.log("actual", $scope.actualLocation);
                    if ($scope.actualLocation === "/customer" && $location.path() === "/login" || $scope.actualLocation === "/login" && $location.path() === "/login") {
                        $scope.doLogout(e);
                    }
                });

                $scope.doLogout = (event: MouseEvent): void => {
                    event.preventDefault();

                    let finalizeLogout = () => {
                        _self.MainService.cleanJWT();

                        blockUI.stop();

                        _self.$state.go("login");
                    };

                    var confirm: angular.material.IConfirmDialog = $mdDialog.confirm()
                        .title($translate.instant("generic.logout.confirm.title"))
                        .textContent($translate.instant("generic.logout.confirm.body"))
                        .targetEvent(event)
                        .ok($translate.instant("generic.logout.confirm.ok-button"))
                        .cancel($translate.instant("generic.logout.confirm.cancel-button"))
                        .openFrom("#btn-logout-header")
                        .closeTo("#btn-logout-header");

                    $mdDialog.show(confirm).then(() => {
                        blockUI.start();

                        _self.HeaderService.logout.query({
                        }).$promise.then(() => {
                            console.log("logout ok");

                            finalizeLogout();
                        }).catch((error: AdeMesError) => {
                            console.error("error on do logout:", error);

                            finalizeLogout();
                        });
                    }).catch(() => {
                        //NOTHING TO DO
                    });
                };

                $scope.goPrevState = (event: MouseEvent): void => {
                    event.preventDefault();

                    $window.history.back();
                };

                $scope.showReportListLink = (): boolean => {
                    return _self.RolesService.loggedUserHasRole("ROLE_BASE")
                        && $state.current.name === "customers";
                };

                $scope.showCustomersLink = (): boolean => {
                    return _self.RolesService.loggedUserHasRole("ROLE_BASE")
                        && $state.current.name !== "customers";
                };

                $scope.goToReportList = (event: MouseEvent): void => {
                    event.preventDefault();

                    $state.go("report-list");
                };

                $scope.goToCustomers = (event: MouseEvent): void => {
                    event.preventDefault();
                    $state.go("customers");
                };
            }
        ];
    }

    // registro la direttiva
    angular.module("AdeMesApp").directive("tzHeader", ($location: ng.ILocationService, $state: angular.ui.IStateService, MainService: any, RolesService: any, HeaderService: any, toaster: toaster.IToasterService, $translate: angular.translate.ITranslateService) => new Header.HeaderDirective($location, $state, MainService, RolesService, HeaderService, toaster, $translate));
}
